import { SiteReportUtilitySteps } from "../../../../react-migration/domains/sites/typings/SiteUtilityReport";
import { siteStore } from "../store";

export const setActiveSiteReportUtilityStep = (activeStep: SiteReportUtilitySteps) =>
  (siteStore.activeSiteReportUtilityStep = activeStep);
